import React, { useEffect, useState } from 'react';
import { Switch } from 'ui/common/switch/switch';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { STATE } from 'app/constants';
import { caseListingTranslation } from 'app/area/case-report/case-listing/constants';
import { useCaseListingTotalResults, useCaseTableViewTotalResults }
  from 'app/area/case-report/components/case-listing-hits-and-toggle-hooks';

import styles from './../case-report-view.scss';
import { LayoutTypeValue } from 'app/area/case-report/constants';

interface CaseTableViewToolbarProps {
  errorsExecuteFailed?: string[];
  autoExecute: boolean;
  toggleAutoExecution: () => void;
  selectedLayout: LayoutTypeValue;
}

function MemoizedCaseListingHeader({ autoExecute, toggleAutoExecution, selectedLayout }: CaseTableViewToolbarProps) {
  const translation: Record<string, string> = useTranslation(STATE.caseListing, caseListingTranslation);
  const { caseListingTotalResults } = useCaseListingTotalResults();
  const { caseTableViewTotalResults } = useCaseTableViewTotalResults();
  const [totalCases, setTotalCases] = useState<number | null>();

  useEffect(() => {
    if (selectedLayout === LayoutTypeValue.tiles || selectedLayout === LayoutTypeValue.bowtie) {
      setTotalCases(caseListingTotalResults);
    } else if (selectedLayout === LayoutTypeValue.table) {
      setTotalCases(caseTableViewTotalResults);
    } else {
      setTotalCases(null);
    }
  }, [caseListingTotalResults, caseTableViewTotalResults, selectedLayout]);

  return (
    <div className={styles.switchWrapper}>
      {(totalCases && autoExecute) ? (
        <div className={styles.hits}>
          {`${totalCases || ''} ${translation.search_hits}`}
        </div>
      ) : null
      }
      <Switch
        checked={autoExecute}
        onChange={toggleAutoExecution}
        label={translation.toggle_info_load_options}
        className={styles.switch}
      />
    </div>
  );
}

export const CaseListingHeader = React.memo(MemoizedCaseListingHeader);
